import { render, staticRenderFns } from "./ShowcaseNav.vue?vue&type=template&id=54982b5a"
import script from "./ShowcaseNav.vue?vue&type=script&lang=js"
export * from "./ShowcaseNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports